/**
 * useHomePath — returns the home panel path for the current user's effective role (TOG-01).
 *
 * An admin with no view-as overlay → "/admin".
 * An admin viewing as technician → "/tecnico".
 * A technician → "/tecnico".
 *
 * Use this for all "volver a mis informes" / back navigation so admins land
 * on /admin instead of the hardcoded /tecnico.
 */
import { useAuth } from "./useAuth.js";
import { useViewAs } from "../view-as.context.js";
import { resolveViewRole, homePathForRole } from "../view-role.js";

export function useHomePath(): "/admin" | "/tecnico" {
  const { user } = useAuth();
  const { viewAs } = useViewAs();
  const effectiveRole = resolveViewRole(user?.rol ?? "technician", viewAs);
  return homePathForRole(effectiveRole);
}
